import { useUserById } from "../useUserById.ts";
import { UserDetailModalWithActions } from "../UserDetailModalWithActions.tsx";

export function StudentDetailModal({
  userId,
  onClose,
}: {
  userId: string;
  onClose: () => void;
}) {
  const { user } = useUserById(userId);
  if (!user) return null;
  return <UserDetailModalWithActions user={user} onClose={onClose} />;
}
